import React, { useEffect, useState } from 'react';
import './SourceText.css';
import { getTextFromSefaria } from '../../services/sefaria.service';

const SourceText = (props) => {
  const { sourceText, setError, selectedVerse, setSelectedVerse } = props;
  const [hebrewText, setHebrewText] = useState({});
  const [englishText, setEnglishText] = useState({});

  const handleVerseClick = (ref) => {
    setSelectedVerse(prev => prev === ref ? null : ref);
  };

  const buildRef = (chapterOffset, verseIndex) => {
    const { book, sections } = hebrewText;
    const chapter = parseInt(sections[0]) + chapterOffset;
    const startVerse = chapterOffset === 0 && sections.length > 1 ? parseInt(sections[1]) : 1;
    return `${book} ${chapter}:${startVerse + verseIndex}`;
  };

  const initializeText = async (text) => {
    const hebrewText = await getTextFromSefaria(text, 'hebrew');
    const englishText = await getTextFromSefaria(text, 'english');
    return { hebrewText, englishText };
  };
  
  
  useEffect(() => {
    initializeText(sourceText).then(response => {
      setHebrewText(response.hebrewText);
      setEnglishText(response.englishText);
      setError(false);
    }).catch(error => {
      setHebrewText({});
      setEnglishText({});
      setError(true);
      console.error("Error fetching text from Sefaria:", error);
    });
  }, [sourceText]);


  const renderVerse = (hebrewHtml, englishHtml, ref, key) => (
    <div
      key={key}
      className={`source-text-segment${selectedVerse === ref ? ' source-text-segment--selected' : ''}`}
      onClick={() => handleVerseClick(ref)}
    >
      <div className="source-text-content source-text-hebrew">
        <span dangerouslySetInnerHTML={{ __html: hebrewHtml }} />
      </div>
      <div className="source-text-content source-text-english">
        <span dangerouslySetInnerHTML={{ __html: englishHtml ?? '' }} />
      </div>
    </div>
  );

  return (
    <div className="source-text-container">
      {hebrewText?.versions?.map((hebrewVersion, chapterIndex) => {
        const englishVersion = englishText?.versions?.[chapterIndex];

        if (!Array.isArray(hebrewVersion.text)) {
          return (
            <div key={chapterIndex} className="source-text-version">
              <div className="source-text-segment">
                <div className="source-text-content source-text-hebrew">
                  <span dangerouslySetInnerHTML={{ __html: hebrewVersion.text }} />
                </div>
                <div className="source-text-content source-text-english">
                  <span dangerouslySetInnerHTML={{ __html: englishVersion?.text ?? '' }} />
                </div>
              </div>
            </div>
          );
        }

        return (
          <div key={chapterIndex} className="source-text-version">
            {hebrewVersion.text.map((textItem, outerIndex) => {
              if (Array.isArray(textItem)) {
                // Multi-chapter: textItem is one chapter's array of verses
                return textItem.map((verseText, verseIndex) => {
                  const ref = buildRef(outerIndex, verseIndex);
                  return renderVerse(
                    verseText,
                    englishVersion?.text?.[outerIndex]?.[verseIndex],
                    ref,
                    `${outerIndex}-${verseIndex}`
                  );
                });
              }
              // Single chapter: textItem is a verse string
              const ref = buildRef(0, outerIndex);
              return renderVerse(
                textItem,
                englishVersion?.text?.[outerIndex],
                ref,
                outerIndex
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default SourceText;
